import React, { Component } from 'react';

import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';
import faqHeaderBg from '../../assets/images/faqBg.png'
import Footer from '../../components/Footer'
import CategoryItemIcon from "../../components/Calculator-board/Category-item/Category-item-icon";
import { Link } from "react-router-dom";
import faqbg from "../../assets/images/faqBg.png";
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux'
// import {FaqContent}  from './faqContent'
import ContactUsMap from './ContactUsMap'
import './ContactUs.css'

class CategoryDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="contact-us-container">
                <div className="Head">
                    <Header />
                    <Navigation />
                </div>
                <div className="contact-us-container-header">
                    <div className="contact-us-container-header-background">
                        <img src={faqbg} alt="Compulsory Insurance Center" title="contact us" />
                    </div>

                    <div className="contact-us-header-wrapper"></div>
                    <div className="contact-us-header-content">
                        <div className="contact-us-header-text">
                            <h1>{this.props.translate("contact-us-header")}</h1>
                            {/* <h5>{this.props.translate("PolicySearchPortalByIndividualPersons")}</h5> */}
                        </div>
                    </div>
                </div>

                <div className="contact-us-content">
                    <div className="contact-us-map">
                        <ContactUsMap
                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyACeU8sExIFC7Sz85xO_1dZXcWXJuCUNpQ&v=3.exp&libraries=geometry,drawing,places"
                            loadingElement={<div style={{ height: `100%` }} />}
                            containerElement={<div style={{ height: `400px` }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                        />
                    </div>
                    <div className="contact-us-text">
                        <span>{this.props.translate("contact-us-line")}
                            <a href="tel:+995322301111"> +995 322 30 1111</a>
                        </span>
                        <span>{this.props.translate("contact-us-adress")}
                            <p>
                                {this.props.translate("contact-us-adress-content")}
                            </p>
                        </span>
                        <span>{this.props.translate("contact-us-tel")}
                            <p> +995 322 23 1111</p>
                        </span>
                        <span>{this.props.translate("contact-us-email")}
                            <a href="mailto:info@tpl.ge">info@tpl.ge</a>
                        </span>
                        <span>{this.props.translate("contact-us-webPage")}
                            <Link to='/'> www.tpl.ge </Link>
                        </span>
                    </div>
                </div >

                <Footer />
            </div >
        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),

})
export default connect(mapStateToProps)(CategoryDescription)






// WEBPACK FOOTER //
// ./src/pages/ContactUs/ContactUs.js